var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es6.string.repeat.js
// module id = 578
// module chunks = 0